<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="68px"
    >
      <el-form-item>
        <el-button type="primary" size="mini" @click="handleQuery"
          >刷新</el-button
        >
      </el-form-item>
    </el-form>

    <el-table ref="tables" v-loading="loading" :data="list">
      <el-table-column
        label="操作人员"
        align="center"
        prop="operName"
        width="180"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="操作记录"
        align="center"
        prop="msg"
        min-width="300"
        :show-overflow-tooltip="true"
        :formatter="formatterMsg"
      />

      <el-table-column
        label="操作日期"
        align="center"
        prop="operTime"
        width="200"
      >
      </el-table-column>
    </el-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="queryParams.pageNum"
      :page-size.sync="queryParams.pageSize"
      :total="queryParams.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!--
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    /> -->
  </div>
</template>

<script>
import { list } from "@/api/operLog";

export default {
  name: "LogList",
  props: {
    rowInfo: {
      type: Object,
      default: () => {}
    },
    logType: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      refuseArr: [
        {
          name: "行驶证",
          value: "",
          type: "c01"
        },
        {
          name: "挂车信息",
          value: "",
          type: "c02"
        },
        {
          name: "道路运输证",
          value: "",
          type: "c03"
        },
        {
          name: "经营许可证",
          value: "",
          type: "c04"
        },
        {
          name: "其他信息",
          value: "",
          type: "c05"
        },
        {
          name: "其他原因",
          value: "",
          type: "c06"
        }
      ],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 表格数据
      list: [],
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 默认排序
      defaultSort: { prop: "operTime", order: "descending" },
      // 表单参数
      form: {},
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        reviewCode: null,
        businessType: 6
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handlePageChange() {
      this.getList();
    },
    replaceTypeWithName(str, arr) {
      const hasType = arr.some(item => str.includes(item.type));
      if (hasType) {
        arr.forEach(item => {
          if (str.includes(item.type)) {
            str = str.replace(item.type, item.name);
          }
        });
      }

      return str;
    },
    formatterMsg(state) {
      return this.replaceTypeWithName(state.msg, this.refuseArr);
    },
    /** 查询登录日志 */
    getList() {
      this.queryParams.reviewCode = this.rowInfo.code;
      this.loading = true;
      this.queryParams.businessType = this.logType === "source" ? 7 : 6;
      if (this.rowInfo.reviewGpsCode) {
        this.queryParams.reviewCode = this.rowInfo.reviewGpsCode;
        this.queryParams.businessType = 12;
      }
      list(this.queryParams).then(response => {
        this.list = response.data.records;
        this.queryParams.total = response.data.total;
        this.loading = false;
      });
    },
    // 操作日志类型字典翻译
    // typeFormat(row, column) {
    //   return this.selectDictLabel(this.dict.type.sys_oper_type, row.businessType)
    // },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.queryParams.pageNum = 1;
      this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order);
    }
    /** 多选框选中数据 */
    // handleSelectionChange(selection) {
    //   this.ids = selection.map(item => item.operId)
    //   this.multiple = !selection.length
    // },
    /** 排序触发事件 */
    // handleSortChange(column, prop, order) {
    //   this.queryParams.orderByColumn = column.prop
    //   this.queryParams.isAsc = column.order
    //   this.getList()
    // },
    /** 详细按钮操作 */
    // handleView(row) {
    //   this.open = true
    //   this.form = row
    // },
    /** 删除按钮操作 */
    // handleDelete(row) {
    //   const operIds = row.operId || this.ids
    //   this.$modal.confirm('是否确认删除日志编号为"' + operIds + '"的数据项？').then(function() {
    //     return delOperlog(operIds)
    //   }).then(() => {
    //     this.getList()
    //     this.$modal.msgSuccess("删除成功")
    //   }).catch(() => {})
    // },
    /** 清空按钮操作 */
    // handleClean() {
    //   this.$modal.confirm('是否确认清空所有操作日志数据项？').then(function() {
    //     return cleanOperlog()
    //   }).then(() => {
    //     this.getList()
    //     this.$modal.msgSuccess("清空成功")
    //   }).catch(() => {})
    // },
    /** 导出按钮操作 */
    // handleExport() {
    //   this.download('monitor/operlog/export', {
    //     ...this.queryParams
    //   }, `operlog_${new Date().getTime()}.xlsx`)
    // }
  }
};
</script>
